import { Divider, Flex, Switch, Typography } from "antd";
import { useToken } from "../../hooks/useToken";

const { Title, Text } = Typography;

export function NotificationBox() {
  const { token } = useToken();

  const NotificationItem = ({
    label,
    checked,
    onChange,
  }: {
    label: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
  }) => (
    <Flex
      justify="space-between"
      align="center"
      style={{ width: "100%", marginBottom: token.marginSM }}
    >
      <Text>{label}</Text>
      <Switch defaultChecked={checked} onChange={onChange} />
    </Flex>
  );

  return (
    <Flex
      style={{
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Flex
        vertical
        style={{
          width: "900px",
          maxWidth: "100%",
          margin: "0 auto",
        }}
        gap={token.marginLG}
      >
        <Flex vertical>
          <Title level={4}>Notifications and Alerts</Title>
          <Divider style={{ marginTop: token.marginXS, marginBottom: 0 }} />
        </Flex>

        <Flex vertical gap={token.margin}>
          <Text style={{ fontWeight: 400, fontSize: token.fontSizeLG }}>
            Email notification:
          </Text>
          <NotificationItem label="Placeholder" checked={true} />
          <NotificationItem label="Placeholder" checked={true} />
          <NotificationItem label="Placeholder" checked={true} />
        </Flex>

        <Flex
          vertical
          gap={token.margin}
          style={{
            marginTop: "32px",
          }}
        >
          <Text style={{ fontWeight: 400, fontSize: token.fontSizeLG }}>
            Push notification:
          </Text>
          <NotificationItem label="Placeholder" checked={true} />
          <NotificationItem label="Placeholder" checked={true} />
          <NotificationItem label="Placeholder" checked={true} />
        </Flex>
      </Flex>
    </Flex>
  );
}
